import { c as _c } from "react/compiler-runtime";
import { COUNTRIES } from '@onefootprint/core';
import { Divider, Form, type TemplateInputProps } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useAutoDataIdentifier } from '../../../hooks/use-auto-data-identifier';
import type { CustomQuestionsFormData } from '../../../types';
import DataIdentifierField from '../data-identifier-field';
type AddressFormProps = {
  questionIndex: number;
  autocompleteItems?: TemplateInputProps['autocompleteItems'];
};
const AddressForm = t0 => {
  const $ = _c(75);
  const {
    questionIndex,
    autocompleteItems
  } = t0;
  const {
    t
  } = useTranslation("playbook-custom-questions");
  const {
    control
  } = useFormContext();
  useAutoDataIdentifier(questionIndex);
  const t1 = `questions.${questionIndex}.dataIdentifier`;
  let t2;
  if ($[0] !== control || $[1] !== t1) {
    t2 = {
      control,
      name: t1
    };
    $[0] = control;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const dataIdentifier = useWatch(t2);
  const t3 = dataIdentifier ?? "";
  let t4;
  if ($[3] !== t3) {
    t4 = t3.startsWith("id.");
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const isIdentity = t4;
  const t5 = dataIdentifier ?? "";
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== autocompleteItems || $[6] !== isIdentity || $[7] !== questionIndex || $[8] !== t || $[9] !== t5) {
    const addressPrefix = t5.replace(/^custom\./, "");
    t8 = "flex flex-col gap-4";
    const t15 = `questions.${questionIndex}.label`;
    let t16;
    if ($[19] !== t) {
      t16 = t(_temp);
      $[19] = t;
      $[20] = t16;
    } else {
      t16 = $[20];
    }
    let t17;
    if ($[21] !== t) {
      t17 = t(_temp2);
      $[21] = t;
      $[22] = t17;
    } else {
      t17 = $[22];
    }
    let t18;
    if ($[23] !== autocompleteItems) {
      t18 = autocompleteItems ?? {};
      $[23] = autocompleteItems;
      $[24] = t18;
    } else {
      t18 = $[24];
    }
    if ($[25] !== t15 || $[26] !== t16 || $[27] !== t17 || $[28] !== t18) {
      t9 = <Form.TemplateInput name={t15} label={t16} placeholder={t17} size="compact" autocompleteItems={t18} />;
      $[25] = t15;
      $[26] = t16;
      $[27] = t17;
      $[28] = t18;
      $[29] = t9;
    } else {
      t9 = $[29];
    }
    const t19 = `questions.${questionIndex}.required`;
    let t20;
    if ($[30] !== t) {
      t20 = t(_temp3);
      $[30] = t;
      $[31] = t20;
    } else {
      t20 = $[31];
    }
    if ($[32] !== t19 || $[33] !== t20) {
      t10 = <Form.Toggle name={t19} label={t20} size="compact" />;
      $[32] = t19;
      $[33] = t20;
      $[34] = t10;
    } else {
      t10 = $[34];
    }
    const t21 = `questions.${questionIndex}.allowPoBox`;
    let t22;
    if ($[35] !== t) {
      t22 = t(_temp4);
      $[35] = t;
      $[36] = t22;
    } else {
      t22 = $[36];
    }
    if ($[37] !== t21 || $[38] !== t22) {
      t11 = <Form.Toggle name={t21} label={t22} size="compact" />;
      $[37] = t21;
      $[38] = t22;
      $[39] = t11;
    } else {
      t11 = $[39];
    }
    const t23 = `questions.${questionIndex}.supportedCountries`;
    let t24;
    if ($[40] !== t) {
      t24 = t(_temp5);
      $[40] = t;
      $[41] = t24;
    } else {
      t24 = $[41];
    }
    let t25;
    if ($[42] !== t) {
      t25 = t(_temp6);
      $[42] = t;
      $[43] = t25;
    } else {
      t25 = $[43];
    }
    let t26;
    if ($[44] !== t25) {
      t26 = {
        text: t25
      };
      $[44] = t25;
      $[45] = t26;
    } else {
      t26 = $[45];
    }
    let t27;
    if ($[46] !== t) {
      t27 = t(_temp7);
      $[46] = t;
      $[47] = t27;
    } else {
      t27 = $[47];
    }
    let t28;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
      t28 = COUNTRIES.map(_temp8);
      $[48] = t28;
    } else {
      t28 = $[48];
    }
    if ($[49] !== t23 || $[50] !== t24 || $[51] !== t26 || $[52] !== t27) {
      t12 = <Form.MultiSelect name={t23} label={t24} tooltip={t26} placeholder={t27} size="compact" options={t28} />;
      $[49] = t23;
      $[50] = t24;
      $[51] = t26;
      $[52] = t27;
      $[53] = t12;
    } else {
      t12 = $[53];
    }
    if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <Divider variant="secondary" />;
      $[54] = t13;
    } else {
      t13 = $[54];
    }
    let t29;
    if ($[55] !== t) {
      t29 = t(_temp9);
      $[55] = t;
      $[56] = t29;
    } else {
      t29 = $[56];
    }
    let t30;
    if ($[57] !== t) {
      t30 = t(_temp10);
      $[57] = t;
      $[58] = t30;
    } else {
      t30 = $[58];
    }
    if ($[59] !== questionIndex || $[60] !== t29 || $[61] !== t30) {
      t14 = <DataIdentifierField questionIndex={questionIndex} label={t29} placeholder={t30} />;
      $[59] = questionIndex;
      $[60] = t29;
      $[61] = t30;
      $[62] = t14;
    } else {
      t14 = $[62];
    }
    t6 = "text-caption-2 text-tertiary";
    t7 = isIdentity ? t(_temp11) : addressPrefix ? t(_temp12, {
      prefix: addressPrefix
    }) : t(_temp13);
    $[5] = autocompleteItems;
    $[6] = isIdentity;
    $[7] = questionIndex;
    $[8] = t;
    $[9] = t5;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t15;
  if ($[63] !== t6 || $[64] !== t7) {
    t15 = <p className={t6}>{t7}</p>;
    $[63] = t6;
    $[64] = t7;
    $[65] = t15;
  } else {
    t15 = $[65];
  }
  let t16;
  if ($[66] !== t10 || $[67] !== t11 || $[68] !== t12 || $[69] !== t13 || $[70] !== t14 || $[71] !== t15 || $[72] !== t8 || $[73] !== t9) {
    t16 = <div className={t8}>{t9}{t10}{t11}{t12}{t13}{t14}{t15}</div>;
    $[66] = t10;
    $[67] = t11;
    $[68] = t12;
    $[69] = t13;
    $[70] = t14;
    $[71] = t15;
    $[72] = t8;
    $[73] = t9;
    $[74] = t16;
  } else {
    t16 = $[74];
  }
  return t16;
};
export default AddressForm;
function _temp($) {
  return $.form.label;
}
function _temp2($_0) {
  return $_0.form.labelPlaceholder;
}
function _temp3($_1) {
  return $_1.form.required;
}
function _temp4($_2) {
  return $_2.form.allowPoBox;
}
function _temp5($_3) {
  return $_3.form.supportedCountriesLabel;
}
function _temp6($_4) {
  return $_4.form.supportedCountriesTooltip;
}
function _temp7($_5) {
  return $_5.form.supportedCountriesPlaceholder;
}
function _temp8(c) {
  return {
    value: c.value,
    label: c.label
  };
}
function _temp9($_6) {
  return $_6.form.dataIdentifierPrefix;
}
function _temp10($_7) {
  return $_7.form.addressPlaceholder;
}
function _temp11($_8) {
  return $_8.form.addressFieldsIdentity;
}
function _temp12($_9) {
  return $_9.form.addressFieldsPrefix;
}
function _temp13($_10) {
  return $_10.form.addressFieldsHint;
}